// extracted by mini-css-extract-plugin
module.exports = {"ourinstituteinnerimg":"institutionCard_ourinstituteinnerimg__1-2KM"};